import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Hero from '../Hero';
import AboutSection from '../Section/AboutSection';
import BrandsSection from '../Section/BrandsSection';
import Banner from '../Section/BannerSection';
import Section from '../Section';
import FeaturesSection from '../Section/FeaturesSection';
import TestimonialSection from '../Section/TestimonialSection';
import FaqSection from '../Section/FaqSection';
import PricingSection from '../Section/PricingSection';
import WhatsAppButton from '../WhatsAppButton';
import RiskManagementModal from '../RiskManagementModal';
import { pageTitle } from '../../helpers/PageTitle';
const brandData = [
  { imgUrl: 'images/chu-fann.png', imgAlt: 'Brand' },
  { imgUrl: 'images/dentec.jpeg', imgAlt: 'Brand' },
  { imgUrl: 'images/yopougon.png', imgAlt: 'Brand' },
  { imgUrl: 'images/cnhu-hkm.png', imgAlt: 'Brand' },
  { imgUrl: 'images/sylvanus.png', imgAlt: 'Brand' },
  { imgUrl: 'images/BMC-LOGO-final.png', imgAlt: 'Brand' },
  { imgUrl: 'images/PISAM-Main-Logo-1.png', imgAlt: 'Brand' },
  { imgUrl: 'images/hogip.jpeg', imgAlt: 'Brand' },
];

export default function Home() {
  pageTitle('Home');
  const { t } = useTranslation();
  
  const [modalData, setModalData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  const handleSubscribeClick = (offerData) => {
    setModalData(offerData);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  const handleAcceptRisk = () => {
    console.log('Utilisateur a accepté les risques pour:', modalData?.title);
  };

  return (
    <>
      <Hero
        title={t('home.hero.title')}
        subTitle={t('home.hero.subTitle')}
        bgUrl="/images/home_1/hero_bg.jepg"
        imgUrl="/images/home_1/pere-enfant.png"
        videoBtnText={t('home.hero.videoBtnText')}
        videoUrl="https://youtube.com/embed/MACrP4-RUrE"
        typewriterStrings={t('home.hero.typewriter', { returnObjects: true })}
        infoList={[
          {
            title: t('home.heroInfo.phone'),
            subTitle: '(+221) 33 824 33 45',
            iconUrl: '/images/icons/call.svg',
          },
          {
            title: t('home.heroInfo.email'),
            subTitle: 'diaspora@transvie.sn',
            iconUrl: '/images/icons/email.svg',
          },
          {
            title: t('home.heroInfo.address'),
            subTitle: 'Lot 2 numéro 440 Zone de captage.',
            iconUrl: '/images/icons/pin.svg',
          },
        ]}
        btnText={t('home.hero.btnText')}
        btnUrl="#"
      />
        <Section
        topMd={100}
        topLg={70}
        topXl={70}
        bottomMd={89}
        bottomLg={89}
        bottomXl={89}
      >
        <PricingSection
          sectionTitle={t('home.pricing.familySectionTitle')}
          data={t('home.pricingData.familyPlans', { returnObjects: true })}
          headerColor="#12AE42"
          titleBgColor="#0171CE"
          onSubscribeClick={handleSubscribeClick}
        />
      </Section>
      <Section
        topMd={100}
        topLg={70}
        topXl={100}
        bottomMd={90}
        bottomLg={90}
        bottomXl={90}
      >
        <PricingSection
          sectionTitle={t('home.pricing.individualSectionTitle')}
          data={t('home.pricingData.individualPlans', { returnObjects: true })}
          headerColor="#0171CE"
          onSubscribeClick={handleSubscribeClick}
        />
      </Section>
      {/* Start Feature Section */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection sectionTitle={t('home.values')} data={t('home.features.list', { returnObjects: true })} />
      </Section>
      {/* End Feature Section */}
      {/* Start Pricing Section */}
     
      {/* End Pricing Section */}
      {/* Start About Section */}
      
      <Section>
        <AboutSection
          imgUrl="/images/home_1/about.png"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title={t('home.about.title')}
          subTitle={t('home.about.subTitle')}
          featureList={t('home.about.featureList', { returnObjects: true })}
        />
      </Section>
    
    
      {/* End About Section */}
      {/* Start Departments Section */}
      {/* <Section topMd={185} topLg={150} topXl={110}>
        <DepartmentSection
          sectionTitle="Departments"
          bgUrl="images/home_1/department_bg.svg"
          data={departmentData}
        />
      </Section> */}

      {/* End Departments Section */}
      {/* Start Award Section */}
    {/*   <Section topMd={185} topLg={140} topXl={100}>
        <AwardSection sectionTitle="Departments" data={awardData} />
      </Section> */}
      {/* End Award Section */}
      {/* Start Testimonial */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSection
          sectionTitle={t('home.testimonials.title')}
          sectionTitleDown={t('home.testimonials.titleDown')}
        />
      </Section>
      {/* End Testimonial */}
      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.svg"
          imgUrl="images/home_1/femme-enfant.png"
          title={t('home.banner.title')}
          subTitle={t('home.banner.subTitle')}
        />
      </Section>
     
      {/* End Blog Section */}
      {/* Start Appointment Section */}
    
      {/* End Appointment Section */}
      {/* Start FAQ Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={t('home.faqData.items', { returnObjects: true })}
          sectionTitle={t('home.faq.title')}
          sectionTitleUp={t('home.faq.up')}
        />
      </Section>
      {/* End FAQ Section */}
      {/* Start Brand Section */}
      <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <BrandsSection data={brandData} />
      </Section>
      {/* End Brand Section */}
      
      {/* WhatsApp Button */}
      <WhatsAppButton />
      
      {/* Modal de gestion des risques */}
      {modalData && (
        <RiskManagementModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          onAccept={handleAcceptRisk}
          offerTitle={modalData.title}
          offerPrice={modalData.price}
        />
      )}
    </>
  );
}
